import { BRAND_DEFAULTS } from '../constants/brandingDefaults';

const FALLBACK_SITE_URL = 'https://elanclacr.com';
const FALLBACK_OG_IMAGE = BRAND_DEFAULTS.og_image_url;

export const DEFAULT_SITE_URL = process.env.REACT_APP_SITE_URL || FALLBACK_SITE_URL;
export const DEFAULT_OG_IMAGE = process.env.REACT_APP_DEFAULT_OG_IMAGE || FALLBACK_OG_IMAGE;
export const DEFAULT_BLOG_DESCRIPTION =
  'Historias, guías y novedades del blog de El Ancla CR para ayudarte a tomar decisiones informadas en cada compra.';

export const getCanonicalUrl = (path = '') => {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}${path}`;
  }
  return `${DEFAULT_SITE_URL}${path}`;
};
